import { echoLoader } from '@betterment/js-runtime';
import { ErrorElement } from '@betterment/shared-components';

import { FullPageLoader } from '../FullPageLoader';
import { EchoRoute } from '../Household/HouseholdSummary/EchoRoute';
import { ReportsEchoRoute } from '../Reports/ReportsEchoRoute';
import { SettingsEchoRoute } from '../Settings/SettingsEchoRoute';

export const echoRoutes = [
  {
    path: '/households/:householdId/members',
    element: <EchoRoute />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_client_management" />,
  },
  {
    path: '/households/:householdId/tax_forms',
    element: <EchoRoute />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_client_management" />,
  },
  {
    path: '/households/:householdId/users/:userId/tax_forms',
    element: <EchoRoute />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_client_management" />,
  },
  {
    path: '/households/:householdId/settings',
    element: <EchoRoute />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_client_management" />,
  },
  {
    path: '/households/:householdId/realized_gain_loss_reports',
    element: <EchoRoute />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_client_management" />,
  },
  {
    path: '/households/:householdId/cost_basis_reports',
    element: <EchoRoute />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_client_management" />,
  },
  {
    path: '/households/:householdId/dividend_reports',
    element: <EchoRoute />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_client_management" />,
  },
  {
    path: '/households/:householdId/crypto_reports',
    element: <EchoRoute />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_client_management" />,
  },
  {
    path: '/reports/fee_statements',
    element: <ReportsEchoRoute activeTab="fee_statements" />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_reports" />,
  },
  {
    path: '/reports/tax_forms',
    element: <ReportsEchoRoute activeTab="tax_forms" />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_reports" />,
  },
  {
    path: '/reports/firm_fee_accruals',
    element: <ReportsEchoRoute activeTab="firm_fee_accruals" />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_reports" />,
  },
  {
    path: '/admin/firm',
    element: <SettingsEchoRoute activeTab="firm" />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_settings" />,
  },
  {
    path: '/admin/firm/fee',
    element: <SettingsEchoRoute activeTab="fees" />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_settings" />,
  },
  {
    path: '/security_settings',
    element: <SettingsEchoRoute activeTab="security" />,
    loader: echoLoader,
    hydrateFallbackElement: <FullPageLoader />,
    errorElement: <ErrorElement feature="advisor_settings" />,
  },
];
